module.exports = __webpack_public_path__ + "img/image.7c92a99a.png";